import { SearchResponse } from './../../../models/search-response';
import { Injectable } from '@angular/core';
import { PlatformHttpService } from '../../../common/http/service/platformhttp.service';
import { HttpParams } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Constants } from '../../../common/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private unsubscribe: Subject<void> = new Subject();

  constructor(public platformhttpservice: PlatformHttpService,
    public activatedRoute: ActivatedRoute,
    public router: Router) { }

  public performSearch(params: HttpParams): Observable<SearchResponse> {
    if (params['updates']) {
      return this.platformhttpservice.get(Constants.SEARCH, params);
    } else {
      // just return empty object when http://localhost:9090/search without ?q=  so we can display appropriate error message
      return of();
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
